/** Couleurs alignées sur l'app mobile CrushShy */
export const crushPink = '#FF4D8D';
export const crushPurple = '#7A5CFF';
export const crushCard =
  'bg-gradient-to-br from-[#1a1024] to-[#0f0a16] rounded-xl border border-pink-500/15';
export const crushInput =
  'w-full px-4 py-2.5 bg-[#0a0a0b] border border-pink-500/20 rounded-lg text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500/40';
export const crushBtnPrimary =
  'px-5 py-2.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:opacity-95 transition-opacity';
